import React from 'react';

export default function LookupOpportunityError({ message }: { message: string }) {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h3>Unable to Load Fund Opportunity</h3>
      <p>{message}</p>
      <p>Please check the URL or contact support if the problem persists.</p>
    </div>
  );
}
